export const isNonEmptyValue = (value: string): boolean => {
  if (value.length > 0) {
    return value.trim() !== '';
  }

  return true;
};
